import { any } from "prop-types";

export const strings = {
    title: 'Olá',
    language: 'Idioma',
    titleTutorial: 'App G13BJJ - Tutorial',
    menuStudents: 'Alunos',
    menuInstructors: 'Professores',
    subtitleTutorial: 'Navegue pelos temas abaixo para descobrir mais sobre as funcionalidades do App G13BJJ',
    tutorialFull: 'Tutorial completo',
    questionsGroup: {
        'questionGroup1': 'Idioma',
        'questionGroup2': 'Conta de acesso',
        'questionGroup3': 'Treinos e checkins',
        'questionGroup4': 'Unidades',
        'questionGroup5': 'Planejamento anual de aulas',
        'questionGroup6': 'Acompanhar progresso',
        'questionGroup7': 'Kids',
        'questionGroup8': 'Hierarquia de técnicas',
        'questionGroup9': 'Meus alunos',
        'questionGroup10': 'Minha(s) unidade(s)',
        'questionGroup11': 'Minhas aulas da semana',
    },
    questions: {
        'question1': 'Alterar idioma',
        'question2': 'Criar uma conta de acesso',
        'question3': 'Vincular-se a uma Unidade G13',
        'question4': 'Acessar com uma conta de acesso já existente',
        'question5': 'Esqueci minha senha',
        'question6': 'Alterar a senha',
        'question7': 'Alterar nome, unidade, professor e/ou data de nascimento',
        'question8': 'Incluir/alterar foto de perfil',
        'question9': 'Visualizar treinos de uma unidade',
        'question10': 'Fazer checkins',
        'question11': 'Visualizar treinos realizados',
        'question12': 'Ver lista das Unidades G13BJJ',
        'question13': 'Criar uma unidade',
        'question14': 'Ver planejamento anual de aulas',
        'question15': 'Visualizar o progresso na faixa',
        'question16': 'Cadastrar um aluno menor de 16 anos (aluno kids)',
        'question17': 'Editar o cadastro de um aluno menor de 16 anos (aluno kids)',
        'question18': 'Fazer checkin de um aluno menor de 16 anos (aluno kids)',
        'question19': 'Visualizar hierarquia de técnicas e vídeos das posições',
        'question20': 'Listar meus alunos',
        'question21': 'Listar meus novos alunos',
        'question22': 'Aprovar lista de novos alunos',
        'question23': 'Aprovar cadastro de um aluno',
        'question24': 'Visualizar progresso do aluno',
        'question25': 'Zerar quantidade de checkins atribuídos automaticamente no cadastro',
        'question26': 'Editar dados do aluno (apenas informações da graduação)',
        'question27': 'Atribuir um novo grau para o aluno',
        'question28': 'Enviar uma mensagem para o aluno',
        'question29': 'Desativar temporariamente o cadastro do aluno - O aluno continuará associado com a unidade e com o professor mas não poderá realizar checkin nos treinos',
        'question30': 'Remover o aluno da equipe - O aluno será desassociado da unidade e do professor',
        'question31': 'Ver minhas unidades',
        'question32': 'Editar minha unidade',
        'question33': 'Criar/editar grade de aulas da minha unidade',
        'question34': 'Incluir/remover professores da minha unidade',
        'question35': 'Visualizar minhas aulas da semana',
        'question36': 'Criar minhas aulas da semana',
        'question37': 'Incluir vídeos de posições na aula',
        'question38': 'Editar uma aula já criada',
        'question39': 'Abrir uma aula para que os alunos realizem checkin',
        'question40': 'Ver checkins realizados na minha aula',
        'question41': 'Incluir (ou remover) um aluno na aula (fazer checkin para o aluno)',
        'question42': 'Visualizar lista de alunos presentes na aula que estão aptos a ganharem um grau',
        'question43': 'Atribuir graus para os alunos a partir da listagem de checkins',
    },
}